import EventsLoggingService from 'js/EventsLoggingService';
import MapLoad from 'client/controllers/MapLoad';
import water_sidebar from 'client/controllers/water_sidebar';
import environment_sidebar from 'client/controllers/environment_sidebar';
import zoning_sidebar from 'client/controllers/zoning_sidebar';
import provincial_plan_sidebar from 'client/controllers/provincial_plan_sidebar';
import oplu_sidebar from 'client/controllers/oplu_sidebar';
import municipal_plan_sidebar from 'client/controllers/municipal_plan_sidebar';
import devapp_sidebar from 'client/controllers/devapp_sidebar';
import Report from 'client/controllers/Report';
import Login from 'client/controllers/Login';
import Register from 'client/controllers/Register';

const { EventTypes } = EventsLoggingService;

/**
 * Simple helper so you can dump objects with console.dump(object)
 */
(function() {
    console.dump = function(object) {
        if (window.JSON && window.JSON.stringify)
            console.log(JSON.stringify(object));
        else
            console.log(object);
    };
})();

var controllers = angular.module('myp.controllers',['ngAnimate','ui.bootstrap','countTo','rzModule','toggle-switch']);

controllers.controller('MapLoadCtrl', [
  '$scope','datorontoService','authenticationService','historyService','sidebarService','$location','$timeout',
    '$interval','$rootScope','Maps','ngDialog','$routeParams','$route','$tooltip','$window','USER_ROLES',
    'AUTH_EVENTS','googleMapsFactory',
  MapLoad
]);

controllers.controller('WaterCtrl',[
  '$scope','$window','$rootScope','sidebarService',
  water_sidebar
]);

controllers.controller('EnivronCtrl',[
  '$scope','Maps','$window','$rootScope','sidebarService',
  environment_sidebar
]);

controllers.controller('ByLawCtrl', [
  '$scope','$window','ngDialog','$rootScope', 'authenticationService', 'USER_ROLES', '$q','sidebarService',
  zoning_sidebar
]);

controllers.controller('ProvincialCtrl',[
  '$scope','$window','$rootScope','sidebarService',
  provincial_plan_sidebar
]);

controllers.controller('OfficialCtrl',[
  '$scope','$window','$rootScope','sidebarService',
  oplu_sidebar
]);

controllers.controller('CityWideCtrl',[
  '$scope','Maps','$window','$rootScope','sidebarService',
  municipal_plan_sidebar
]);

//Controller for Developement Application
controllers.controller('devapp_sidebarCtrl',[
  '$scope','Maps','$window','$rootScope','datorontoService','$compile','$timeout','ngDialog', 'historyService','sidebarService',
  devapp_sidebar
]);

//Controller for Planning Report
controllers.controller('ReportCtrl',[
  '$scope','$location','ngDialog','$rootScope','reportService','$timeout','datorontoService','$window','lockService','sidebarService',
  Report
]);

//Controller for Contact Us
controllers.controller('ContactCtrl',['$scope','ngDialog',
    function ($scope, ngDialog) {


    }]);

//Controller for informing the User that they can't access the prime sidebar content
controllers.controller('PrimeCtrl',['$rootScope','$scope','Maps','ngDialog',
    function($rootScope, $scope,Maps,ngDialog){
        $scope.PrimeLegend = Maps.query({mapId:'prime-legend'});

        $rootScope.$broadcast('map/setlegend', [$scope.PrimeLegend,"prime content"]);
        $scope.callLogin = function () {
            $scope.showLogin();
        };
        $scope.callSignup = function () {
            ngDialog.closeAll();
            var request = ngDialog.open({
                templateUrl:'templates/tmp_register.tpl.html',
                controller:'registerCtrl',
                className: 'ngdialog-theme-plain'
            });
        };
    }]);

//Controller for Tutorial # 1
controllers.controller('Tut1Ctrl',['$scope','ngDialog','$window',
    function ($scope, ngDialog, $window) {

        /* Close the ngDialog for the user */
        $scope.close = function () {
            EventsLoggingService.clickedTutorial(EventTypes.CLICKED_CLOSED_TUTORIAL);
            ngDialog.closeAll();
        };

        /* Close this ngDialog and open the next tutorial page */
        $scope.next = function(){
            EventsLoggingService.clickedTutorial(EventTypes.CLICKED_NEXT_TUTORIAL1);
            ngDialog.closeAll();

            ngDialog.open({
                template: '/templates/tutorial1.tpl.html',
                controller:'Tut2Ctrl',
                className:'tutorial-theme'
            });
        };

        $scope.next1 = function () {
            EventsLoggingService.clickedTutorial(EventTypes.CLICKED_NEXT_TUTORIAL2);
            ngDialog.closeAll();

            ngDialog.open({
                template: '/templates/tutorial2.tpl.html',
                controller:'Tut1Ctrl',
                className:'tutorial-theme-2'
            });
        };

        $scope.finished = function(){
            EventsLoggingService.clickedTutorial(EventTypes.CLICKED_FINISH_TUTORIAL);
            ngDialog.closeAll();
        };
    }]);

//Controller for Tutorial 1 Page 2
controllers.controller('Tut2Ctrl',['$scope','ngDialog','$window',
    function ($scope, ngDialog, $window) {

        $scope.finished = function(){
            EventsLoggingService.clickedTutorial(EventTypes.CLICKED_FINISH_TUTORIAL1);
            ngDialog.closeAll();
        };
    }]);

//Controller for Tutorial #3
controllers.controller('Tut3Ctrl',['$scope','ngDialog', '$window',
    function ($scope, ngDialog, $window) {

        $scope.finished = function () {
            EventsLoggingService.clickedTutorial(EventTypes.CLICKED_FINISH_TUTORIAL2);
            ngDialog.closeAll();
        };
    }]);

/* Auth controllers below this comment */

//Controller for handling Auth
controllers.controller('loginCtrl',[
  '$scope','authenticationService','reminderService','$location','ngDialog','$window','AUTH_EVENTS','$rootScope',
  Login
]);

//Controller for handling new users
controllers.controller('registerCtrl',[
  '$scope','registerService','$location','ngDialog','$rootScope',
  Register
]);

//Controller for the users settings page
controllers.controller('homeCtrl',['$scope','authenticationService','$location',
    function ($scope,authenticationService,$location) {
        authenticationService.getUser().success(function (data) {
            $scope.name = data.name;
        });
        $scope.logout = function (){
            authenticationService.logout().success(function () {
                $location.path('/login');
            }); //call logout service
        };
    }]);

//Controller for handling resetting forgotten passwords
controllers.controller('ForgotCtrl',['$scope','resetService','$location',
    function($scope,resetService,$location){
        $scope.credentials = {email: ""};
        $scope.isSending = false;
        $scope.forgotpassword = function () {
            $scope.isSending = !$scope.isSending;
            $scope.credentials.email = $scope.credentials.email.toLowerCase();
            resetService.forgotpassword($scope.credentials).success(function () {
                $scope.isSending = !$scope.isSending;
            });
        }

    }]);

//Controller for handling sidebar tutorial actions
controllers.controller('TutorialCtrl',['$scope','authenticationService','$location','ngDialog','$rootScope','$window',
    function($scope,authenticationService,$location,ngDialog,$rootScope,$window){

    }]);

//Controller for handling email activation
controllers.controller('ResetCtrl',['$scope','resetService','$location','$routeParams','$window',
    function($scope,resetService,$location,$routeParams,$window) {
        $scope.message = $window.message;
    }]);

//Controller for retrieving user's property history
controllers.controller('HistoryCtrl',['$scope','historyService','$location',
    function ($scope, historyService, $location) {
        $scope.gethistory = function () {
            historyService.gethistory().success(function (data) {
                $scope.history = data.history;
            });
        };

        $scope.setPath = function (url,address){
            //$location.url(url);
            $location.search('address', address);
            $scope.model.address = address;
            $scope.checkAddress();
        };
    }]);


// WEBPACK FOOTER //
// ./public/js/controllers.js